import Rate, { inactiveStarBackground } from "common/Rate/Rate";
import styled from "styled-components";
import Title from "common/Typography/Title";
import React from "react";
import { MIN_NUM_OF_REVIEWS } from "@shared/features/newMarketplace/constants";
import { getRoundedAvgRating } from "@shared/features/newMarketplace/utils";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface SubGroupRateProps {
  groupAvgStars: number;
  groupNumReviewers: number;
  starsSize: number;
  isShort?: boolean;
}

const GroupRate: React.FC<SubGroupRateProps> = ({
  groupAvgStars,
  groupNumReviewers,
  starsSize,
  isShort,
}) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.MARKETPLACE);
  const roundedAvgStars = getRoundedAvgRating(groupAvgStars);
  const isEnoughReviews = groupNumReviewers >= MIN_NUM_OF_REVIEWS;

  if (isEnoughReviews) {
    return (
      <div>
        <RateWrapper>
          <Rate
            disabled
            allowHalf
            defaultValue={roundedAvgStars}
            style={{ fontSize: starsSize }}
          />
          <StyledTitle
            type={isShort ? "secondary" : "primary"}
            $size={starsSize}
          >
            {groupAvgStars.toFixed(1)}
          </StyledTitle>
          {isShort && (
            <StyledTitle type="secondary" $size={starsSize}>
              ({groupNumReviewers})
            </StyledTitle>
          )}
        </RateWrapper>
        {!isShort && (
          <ReviewsTitle>
            {t("rating.reviews", { count: groupNumReviewers })}
          </ReviewsTitle>
        )}
      </div>
    );
  }
  return <ReviewsTitle>{t("rating.not_enough_reviews")}</ReviewsTitle>;
};

export default GroupRate;

const RateWrapper = styled.div`
  display: flex;
  align-items: center;
  ${(p) => inactiveStarBackground(p.theme.colors.avatarBgColor)};
`;
const StyledTitle = styled(Title)<{ $size: number }>`
  margin-left: 5px;
  font-size: ${(p) => p.$size}px;
`;
const ReviewsTitle = styled(Title).attrs({ level: 5, type: "secondary" })`
  margin-top: 2px;
`;
